import { InvoiceListModel, InvoiceModel } from '../models/invoice.model';

export function getStatus(invoice: InvoiceListModel | InvoiceModel): {
  status: string;
  class: string;
} {
  switch (invoice.paymentStatus) {
    case 'paid':
      return { status: 'Bezahlt', class: 'inwi-chip-text-green-outline' };
    case 'late':
      return { status: 'Verspätet', class: 'inwi-chip-text-yellow-outline' };
    case 'cancelled':
      return { status: 'Storniert', class: 'inwi-chip-text-red-outline' };
    default:
      return { status: 'Ausstehend', class: 'inwi-chip-text-grey-outline' };
  }
}
